import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=580ae522&scoped=true&"
import script from "./order_info.vue?vue&type=script&lang=js&"
export * from "./order_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ae522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580ae522')) {
      api.createRecord('580ae522', component.options)
    } else {
      api.reload('580ae522', component.options)
    }
    module.hot.accept("./order_info.vue?vue&type=template&id=580ae522&scoped=true&", function () {
      api.rerender('580ae522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_info.vue"
export default component.exports